import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import Flex from '@client/components/flex/Flex';
import { deleteAndHandleFundraiserComment } from '@client/redux/fundraiser/fundraiserActions';
import styles from './deleteConfirmation.scss';

function DeleteConfirmation({
  className,
  fundraiserId,
  commentId,
  toggleModal,
  dispatch,
}) {
  function onDeleteComment() {
    return dispatch(
      deleteAndHandleFundraiserComment(fundraiserId, commentId)
    ).catch((error) => {
      console.log('report error', error);
    });
  }

  return (
    <Flex column alignCenter className={className ? className : ''}>
      <h4>Är du säker på att du vill radera detta inlägg?</h4>
      <button
        className={`${styleHelper.btnPrimaryLg} ${styles.deleteBtn}`}
        onClick={onDeleteComment}
        autoFocus={true}
      >
        Ja, radera inlägg
      </button>
      <button className={styleHelper.btnFlat} onClick={toggleModal}>
        Gå tillbaka
      </button>
    </Flex>
  );
}

DeleteConfirmation.propTypes = {
  className: PropTypes.string,
  dispatch: PropTypes.func,
  toggleModal: PropTypes.func,
  fundraiserId: PropTypes.string,
  commentId: PropTypes.string,
};

export default connect()(DeleteConfirmation);
